<template>
  <div class="role-grid-wrapper">
    <div class="roles-grid">
      <div
        v-for="role in sortedRoles"
        :key="role.id"
        class="role-card"
        :class="{'selected': selectedRoles[role.id]}"
        @click="toggleRole(role.id)"
      >
        <div class="d-flex justify-content-between align-items-start mb-1">
          <div class="role-name">{{ role.name }}</div>
          <div class="d-flex align-items-center" style="gap: 4px;">
            <span
              class="role-info-icon-wrapper"
              @click.stop="showPermissions(role)"
              v-c-tooltip="$pgettext('collaborators.roles', 'View permissions')"
            >
              <CIcon
                name="cilInfo"
                size="sm"
                class="role-info-icon"
              />
            </span>
            <CBadge
              v-if="role.role_type"
              :color="getRoleTypeBadgeColor(role.role_type)"
              class="role-type-badge"
            >
              {{ getRoleTypeLabel(role.role_type) }}
            </CBadge>
          </div>
        </div>
        <div v-if="role.description" class="role-description">{{ role.description }}</div>
      </div>

      <div v-if="roles.length === 0" class="text-muted">
        <translate translate-context="collaborators.roles">No roles available</translate>
      </div>
    </div>
  </div>
</template>

<script>
import {sortRolesByPriority} from '../utils/roles'

export default {
  name: 'RoleGrid',

  props: {
    roles: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      // v-model: oggetto {roleId: boolean}
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  computed: {
    sortedRoles() {
      return sortRolesByPriority(this.roles)
    },

    selectedRoles() {
      return this.value
    }
  },

  methods: {
    toggleRole(roleId) {
      const newValue = {...this.value}
      newValue[roleId] = !newValue[roleId]
      this.$emit('input', newValue)
    },

    showPermissions(role) {
      this.$emit('show-permissions', role)
    },

    getRoleTypeLabel(roleType) {
      const labels = {
        'global': this.$pgettext('collaborators.roles', 'Global'),
        'contract_manager': this.$pgettext('collaborators.roles', 'Contract Mgr'),
        'pica_service': this.$pgettext('collaborators.roles', 'Service')
      }
      return labels[roleType] || roleType
    },

    getRoleTypeBadgeColor(roleType) {
      const colors = {
        'global': 'danger',
        'contract_manager': 'warning',
        'pica_service': 'info'
      }
      return colors[roleType] || 'secondary'
    }
  }
}
</script>

<style scoped>
.role-grid-wrapper {
  width: 100%;
}

.roles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  padding: 2px;
}

.role-card {
  border: 2px solid #d8dbe0;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
}

.role-card:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-color: #321fdb;
}

.role-card.selected {
  border-color: #321fdb;
  background-color: #e7f1ff;
}

.role-name {
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  flex: 1;
}

.role-description {
  font-size: 12px;
  color: #768192;
  margin-top: 4px;
  line-height: 1.4;
}

.role-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  flex-shrink: 0;
  text-transform: uppercase;
  font-weight: 600;
}

.role-info-icon-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}

.role-info-icon {
  color: #768192;
  transition: color 0.2s ease;
}

.role-info-icon-wrapper:hover .role-info-icon {
  color: #321fdb;
}
</style>
